import React, { useRef } from 'react';
import { number, node, func, bool } from 'prop-types';

// Import components
import { Root } from './styles';
import GradientButton from './GradientButton';

export function CommonButton({
	onButtonClick,
	width,
	height,
	children,
	disabled
}) {
	const ref = useRef();
	return (
		<Root
			onClick={onButtonClick}
			width={width}
			height={height}
			ref={ref}
			disabled={disabled}
		>
			<GradientButton ref={ref}>{children}</GradientButton>
		</Root>
	);
}

CommonButton.defaultProps = {
	width: 189,
	height: 59,
	onButtonClick: () => {},
	disabled: false
};

CommonButton.propTypes = {
	width: number,
	height: number,
	children: node,
	onButtonClick: func,
	disabled: bool
};
